/**
 * Safe entity-id equality for dropdowns and lookups.
 *
 * Many SmartAccount entities use GUID string IDs. A bare `parseInt` comparison is dangerous:
 *   parseInt("482ab3-...") === parseInt("482e77-...")  → both 482 → false match
 *
 * Numeric comparison is only used when BOTH values are fully numeric (e.g. "01" vs "1").
 */
export function isSameEntityId(a: unknown, b: unknown): boolean {
  if (a === undefined || a === null || b === undefined || b === null) return false
  const aStr = String(a).trim()
  const bStr = String(b).trim()
  if (!aStr || !bStr) return false
  if (aStr.toLowerCase() === bStr.toLowerCase()) return true
  if (/^\d+$/.test(aStr) && /^\d+$/.test(bStr)) return Number(aStr) === Number(bStr)
  return false
}
